module.exports = __webpack_public_path__ + "static/media/gm.a503c3d6.svg";